<template>
    <v-container fluid class="pa-0">
        <v-row class="align-start px-3">
            <v-col cols="6">
                <v-row class="align-center px-3">
                    <!-- Breadcrumbs -->
                    <v-breadcrumbs
                        :items="[
                            { text: 'Home', disable: false, href: '/#/' },
                            { text: 'P & L', disabled: true }
                        ]"
                        divider="/"
                    ></v-breadcrumbs>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }"
                            ><v-icon small color="grey" v-on="on"
                                >error_outline</v-icon
                            >
                        </template>
                        <span>Refreshed daily</span>
                    </v-tooltip>
                </v-row>
            </v-col>
            <v-spacer />
            <v-col cols="6" md="3" lg="2">
                <v-select
                    v-model="numYears"
                    :items="[1, 2, 3, 4, 5]"
                    label="Show #Years"
                    :menu-props="{ offsetY: true }"
                    hide-details
                    class="mr-3"
                ></v-select>
            </v-col>
        </v-row>

        <v-row v-for="i in numYears" :key="i" class="ma-0 mb-5" align="stretch">
            <PLTable></PLTable>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
// import moment from "moment";
import helper from "@/utils/helper.js";
import PLTable from "@/components/pl/PLTable.vue";

export default {
    components: { PLTable },

    apollo: {
        tenantGreenhouses: {
            query: gql`
                query tenantGreenhouses {
                    tenantGreenhouses(orderBy: "name") {
                        edges {
                            node {
                                id
                                name
                                totalSpaceM2
                                operatingCostRateSet {
                                    edges {
                                        node {
                                            id
                                            month
                                            costPerM2Day
                                            totalCost
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // result({ data, loading }) {
            //     if (!loading) {
            //         this.calculateOperatingCosts(
            //             data.tenantOperatingCosts.edges
            //         );
            //     }
            // },
            loadingKey: "loadingOperatingCostsKey",
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantGreenhouses.edges,
            skip: false
            // pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            monthNames: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],

            numYears: 1
        };
    },
    computed: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {}
};
</script>